import { ReplacementFile } from "features/reducers/replacementOrder/cart.ts";
import { sanitizeBlobName } from "utils/file.ts";
import { uploadFileToBlob } from "utils/blob.ts";

export const MANUAL_PRICE_ADJ = ["0%", "+5%", "+10%", "+20%", "+25%", "+30%", "+40%", "+50%"];
export const MAX_NOTES_LENGTH = 500;
export const DWG_EXTENSION = ".dwg";
export const PDF_EXTENSION = ".pdf";

export const getSingleFileByExtension = (
	uploadedFiles: ReplacementFile[],
	extension: string
): ReplacementFile | undefined => {
	const files = uploadedFiles.filter((file) => file.name.toLowerCase().endsWith(extension));
	return files.length === 1 ? files[0] : undefined;
};

export const uploadFile = async (
	file: ReplacementFile,
	quoteId: string,
	revisionId: number,
	uploadContainerBlob: (
		requestId: string,
		fileName: string,
		blobContent: Blob,
		contentType: string,
		fileSize: number
	) => Promise<string | undefined>
) => {
	const fileName = `${revisionId}/${sanitizeBlobName(file.name)}`;
	const url = await uploadFileToBlob({
		fileUrl: file.fileUrl,
		fileName,
		size: file.size,
		requestId: quoteId,
		uploadContainerBlob
	});

	return { url, fileName };
};

export const validateDwgPdfFiles = (
	uploadedFiles: ReplacementFile[],
	quoteId: string | undefined
): { isValid: boolean; dwgFile?: ReplacementFile; pdfFile?: ReplacementFile } => {
	const dwgFile = getSingleFileByExtension(uploadedFiles, DWG_EXTENSION);
	const pdfFile = getSingleFileByExtension(uploadedFiles, PDF_EXTENSION);

	const isValid = !!(uploadedFiles?.length === 2 && dwgFile && pdfFile && quoteId);

	return { isValid, dwgFile, pdfFile };
};
